import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { ListGroup, ListGroupItem, Popover, PopoverBody } from 'reactstrap';
import { signOut } from "../auth";
import userAvatar from '../styles/user-avatar.jpeg'

function Sidebar() {
  const crtUser = useSelector(state => state.crtUser)
  const [popoverOpen, setPopoverOpen] = useState(false)

  function picOrSignIn() {
    if (crtUser.uid) {
      const photoURL = crtUser.photoURL || userAvatar

      return <>
        <div id="profile-pic">
          <img src={photoURL} alt="profile-picture" />
        </div>

        <Popover
          isOpen={popoverOpen}
          placement="right"
          target="profile-pic"
          trigger="legacy"
          toggle={() => setPopoverOpen(!popoverOpen)}
          offset={[-30, 5]}
        >
          <PopoverBody className='p-1'>
            <ListGroup flush>
              <ListGroupItem onClick={() => setPopoverOpen(false)}>
                <Link to="/profile" className="text-decoration-none">Your Profile</Link>
              </ListGroupItem>
              <ListGroupItem onClick={() => setPopoverOpen(false)}>
                <div id="sign-out-btn" className='text-danger' onClick={signOut}>
                  <i className="bi bi-arrow-bar-left"></i>
                  Sign out
                </div>
              </ListGroupItem>

            </ListGroup>
          </PopoverBody>
        </Popover>
      </>
    }

    return <Link to="/sign-in"><i className="bi bi-power"></i></Link>
  }

  return (
    <div id='sidebar'>
      <div className='section top'>
        <Link to="/"><i className="bi bi-house-heart"></i></Link>
      </div>
      <div className='section bottom'>
        <Link to="/"><i className="bi bi-bell"></i></Link>
        {picOrSignIn()}
      </div>
    </div>
  );
}

export default Sidebar;
